module.exports = __webpack_public_path__ + "img/no-batch.31d7bc3d.png";